import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useAppsStatus = (options?: { enabled?: boolean; refetchInterval?: number }) => {
  return useQuery({
    queryKey: [{ entity: "appsStatus" }],
    queryFn: async () => await apiClient.getAppsStatus(),
    ...options,
  });
};
